import { makeRESTApiRequest } from '../../helpers/api';
import { ENDPOINTS } from '../../helpers/constants';
import { normalizeHoaSnapshot, resolveEntityId } from '../HoaDirectory/HoaDirectoryHelper';

/**
 * Load instruction PDF metadata for order HOA slots (deduped by association/company id).
 * Used so HoaBlock can skip per-slot directory GETs when Edit HOAs opens.
 */
export const prefetchDirectoryFilesForHoaSlots = async slots => {
  if (!Array.isArray(slots) || !slots.length) return [];

  const assocCache = new Map();
  const companyCache = new Map();

  const fetchAssociation = async id => {
    const key = String(id);
    if (assocCache.has(key)) return assocCache.get(key);
    const { response, error } = await makeRESTApiRequest({
      endpoint: ENDPOINTS.ASSOCIATION_WITH_ID(id),
      method: 'GET',
    });
    const value = error ? null : response;
    assocCache.set(key, value);
    return value;
  };

  const fetchCompany = async id => {
    const key = String(id);
    if (companyCache.has(key)) return companyCache.get(key);
    const { response, error } = await makeRESTApiRequest({
      endpoint: ENDPOINTS.MANAGEMENT_COMPANY_WITH_ID(id),
      method: 'GET',
    });
    const value = error ? null : response;
    companyCache.set(key, value);
    return value;
  };

  return Promise.all(
    slots.map(async slot => {
      const hoa = normalizeHoaSnapshot(slot);
      const associationId = resolveEntityId(hoa.associationId);
      const managementCompanyId = resolveEntityId(hoa.managementCompanyId);

      let selfInstructionFiles = [];
      let managementCompanyFiles = [];

      if (hoa.managementType === 'self' && associationId) {
        const assoc = await fetchAssociation(associationId);
        selfInstructionFiles = assoc?.selfInstructionFiles || [];
      } else if (hoa.managementType === 'managed') {
        let companyId = managementCompanyId;
        if (!companyId && associationId) {
          const assoc = await fetchAssociation(associationId);
          companyId = resolveEntityId(assoc?.mgmtId);
        }
        if (companyId) {
          const company = await fetchCompany(companyId);
          managementCompanyFiles = company?.orderingInstructionFiles || [];
        }
      }

      return { selfInstructionFiles, managementCompanyFiles };
    })
  );
};
